import { Text, Title2, WasabiButton } from '@kk/ui';

export interface StateAction {
  label: string;
  onPress: () => void;
}

/**
 * A screen that is only a sentence: a sign-in we refused, one that broke, an invite that has run out.
 * Every one of these was an error CODE on screen before (Evan, 2026-09-16), so the shape matters less
 * than the rule it keeps — a person reads a sentence, and the CTA is absent when there is nothing for
 * them to do.
 */
export function StateCard({
  title,
  body,
  cta,
  link,
  testID,
}: {
  /** Absent for a state that is one sentence (the invite link with no token). */
  title?: string;
  body: string;
  cta?: StateAction;
  link?: StateAction;
  testID?: string;
}) {
  return (
    <div className="sign-in">
      <div className="sign-in-card" data-testid={testID}>
        {title ? <Title2 tone="ink">{title}</Title2> : null}
        <Text variant={title ? 'bodySm' : 'body'} tone={title ? 'slate' : 'ink'}>
          {body}
        </Text>
        {cta ? <WasabiButton label={cta.label} onPress={cta.onPress} testID="state-cta" /> : null}
        {link ? (
          <WasabiButton
            label={link.label}
            variant="text"
            textSize="sm"
            fullWidth={false}
            onPress={link.onPress}
            testID="state-link"
          />
        ) : null}
      </div>
    </div>
  );
}
